module.exports = __webpack_public_path__ + "static/media/header-1.76a565dc.gif";